export const KEYS = {
  firstNameKey: 'first_name',
  lastNameKey: 'last_name',
  schoolNameKey: 'organization',
  emailKey: 'email',
  industryNameKey: 'industry',
  cityNameKey: 'city',
  descriptionKey: 'bio',
  stateNameKey: 'state',
  roleKey: 'role',
  super: 'super',
};

export const STUDENT_INFO_KEYS = {
  guardianNameKey: 'student_info.guardian_name',
  guardianEmailKey: 'student_info.guardian_email',
  teacherNameKey: 'student_info.teacher_name',
  teacherEmailKey: 'student_info.teacher_email',
};
